export const isErrorAction = action =>
  (((action.type && action.type.includes('ERROR')) || action.error)
    && (action.error !== undefined));
